import { Box } from "@mui/material";
import { NavbarIcon } from "../../atoms/navbar/Icon";
import UserTag from "../../components/UserTag";
import {
  BaseFilterOptions,
  BaseFilters,
  FilterOption,
  OrganizationSecret,
  OrganizationVariable,
} from "../../models/types";
import { IColumnVisibility } from "../../molecules/ColumnVisibility";
import { TableTextWithEllipsis } from "../../molecules/TableTextWithEllipsis";
import { defaultDateDisplay } from "../UIHelper";

export const organizationListFilterOptions: FilterOption<BaseFilters>[] = [
  { label: "Name", value: "name" },
  ...BaseFilterOptions,
];

export const organizationVariablesListColumnsVisibility: IColumnVisibility<OrganizationVariable>[] =
  [
    {
      field: "name",
      headerName: "Name",
      visible: true,
      columnMinWidth: 400,
      renderer: (orgVar) => <TableTextWithEllipsis value={orgVar.name} />,
    },
    {
      field: "value",
      headerName: "Value",
      visible: true,
      renderer: (orgVar) => <TableTextWithEllipsis value={orgVar.value} />,
    },
    {
      field: "updated_by",
      headerName: "Updated On",
      visible: true,
      renderer: (orgVar) => {
        return defaultDateDisplay(orgVar.updated_on);
      },
    },
    {
      field: "updated_by",
      headerName: "Updated By",
      visible: true,
      renderer: (orgVar) => {
        return <UserTag name={orgVar.updated_by.name} />;
      },
    },
  ];

export const organizationSecretsListColumnsVisibility: IColumnVisibility<OrganizationSecret>[] = [
  {
    field: "name",
    headerName: "Name",
    visible: true,
    columnMinWidth: 400,
    renderer: (orgVar) => (
      <Box display="flex" flexDirection="row" gap="5px" alignItems="center">
        <NavbarIcon
          variant="lock"
          sx={{
            minWidth: "18px",
            width: "18px",
            height: "18px",
            minHeight: "18px",
          }}
        />
        <TableTextWithEllipsis value={orgVar.name} />
      </Box>
    ),
  },
  {
    field: "updated_by",
    headerName: "Updated On",
    visible: true,
    renderer: (orgVar) => {
      return defaultDateDisplay(orgVar.updated_on);
    },
  },
  {
    field: "updated_by",
    headerName: "Updated By",
    visible: true,
    renderer: (orgVar) => {
      return <UserTag name={orgVar.updated_by.name} />;
    },
  },
];
